import trackClevertapEvents from "@/utils/trackClevertapEvents";
import { Toast } from "@monsterindia/global-ui-components";
import React, { useEffect, useState } from "react";

import {
  getProfileData,
  linkedinConsentUpdate,
} from "@/components/settings/api/networkUtils";
import { useProfileData } from "@/components/settings/contents/profileSettings";

import HeaderContentToggle from "../../../components/common/HeaderContentToggle";
import ProfileDisableReason from "./profile-auto-update-reason";

const ProfileAutoUpdate: React.FC<ProfileAutoUpdateProps> = ({ isMobile }) => {
  const [profileAutoUpdateToggle, setProfileAutoUpdateToggle] =
    useState<boolean>(false);
  const [toast, setToast] = useState({ text: "", type: "", show: false });
  const [profileDisableReason, setProfileDisableReason] = useState<
    string | null
  >(null);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const { successToastOnMsg, toastErrorMsg, profileHeading, profileContent } =
    useProfileData?.profileAutoUpdate || {};

  useEffect(() => {
    const fetchSocialPresence = async () => {
      const profileField = "social_presence";
      const response = await getProfileData(profileField);
      const presences = response?.socialPresenceSection?.presences || [];
      const linkedInSocialProfile = presences.length > 0 ? presences[0] : null;
      const linkedInConsentValue =
        linkedInSocialProfile?.linkedInConsent || false;
      setProfileAutoUpdateToggle(linkedInConsentValue);
    };
    fetchSocialPresence();
  }, []);

  const handleProfileAutoUpdate = async (newToggleValue: boolean) => {
    try {
      const data = await linkedinConsentUpdate(
        newToggleValue,
        profileDisableReason,
      );
      if (data) {
        trackClevertapEvents.eventPush("Profile_update_consent", {
          profile_consent_added: "true",
        });
        setProfileAutoUpdateToggle(newToggleValue);
        setToast({
          text: successToastOnMsg ?? "Profile updated successfully.",
          type: "success",
          show: true,
        });
      }
    } catch (error) {
      setToast({
        text: toastErrorMsg ?? "Something went wrong!",
        type: "error",
        show: true,
      });
    }
  };
  const handleProfileAutoUpdateToggle = async () => {
    const newToggleValue = !profileAutoUpdateToggle;
    if (profileAutoUpdateToggle) {
      setShowReasonModal(true);
    } else {
      await handleProfileAutoUpdate(newToggleValue);
    }
  };

  return (
    <div className="bg-surface-secondary flex flex-col rounded-xl p-3">
      <HeaderContentToggle
        heading={profileHeading}
        content={[profileContent]}
        showToggle={true}
        name="auto-apply"
        isToggleChecked={profileAutoUpdateToggle}
        setToggleVisibility={handleProfileAutoUpdateToggle}
      />
      {showReasonModal && (
        <ProfileDisableReason
          setProfileAutoUpdateToggle={setProfileAutoUpdateToggle}
          profileAutoUpdateToggle={profileAutoUpdateToggle}
          showReasonModal={showReasonModal}
          setShowReasonModal={setShowReasonModal}
          setProfileDisableReason={setProfileDisableReason}
          profileDisableReason={profileDisableReason}
          setToast={setToast}
        />
      )}
      <Toast
        timer={3000}
        showToast={toast.show}
        text={toast.text}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
        width={isMobile ? "75" : "50"}
        position="top-center"
      />
    </div>
  );
};

export default ProfileAutoUpdate;
